<template>
    <!-- TODO css -->
    <modal @close="modals.editGiftBoxCampaign = false" :width="600">
        <h3 v-if="type=='create'">Request New Campaign</h3>
        <h3 v-if="type=='edit'">{{ item.name }} <span>Campaign Settings</span></h3>
        <div class="modal-tabs" >
            <div class="modal-tab-header" :active="activeTab=='campaign'" @click="activateTab('campaign')"><h5>Main Settings</h5></div>
            <div class="modal-tab-header" v-if="type=='create'" :active="activeTab=='options'" @click="activateTab('options')"><h5>Gift Options</h5></div>
            <div class="modal-tab-header" :active="activeTab=='page'" @click="activateTab('page')" v-if="editItem.type=='reviews'"><h5>Review Page</h5></div>
            <div class="modal-tab-header" :active="activeTab=='page'" @click="activateTab('page')" v-else><h5>Gift Claim Page</h5></div>
            <div class="modal-tab-header" :active="activeTab=='sales'" @click="activateTab('sales')" v-if="editItem.type=='sales'"><h5>Sales Metrics</h5></div>
        </div>
        <div class="large-form">
            <div class="modal-tab-content" :active="activeTab=='campaign'">
                <div class="form-line">
                    <div id="form-field-name" class="form-field" style="width: 100%">
                        <label for="form-input-name">Campaign Name</label>
                        <input v-model="editItem.name" type="text" id="form-input-name" required="required" @input="slugify" />
                    </div>
                </div>

                <div class="form-line">
                    <div class="form-field" style="width: 50%">
                        <label>Campaign Type</label>
                        <select v-model="editItem.type">
                          <option value="year-round">Year-Round</option>
                          <option value="seasonal">Seasonal</option>
                          <option value="event">Event</option>
                          <option value="onboarding">Onboarding</option>
                          <option value="sales">Sales</option>
                          <option value="reviews">Reviews</option>
                          <option value="other">Other</option>
                        </select>
                    </div>
                    <div class="form-field" style="width: 50%;">
                        <label for="form-input-reward_type">Reward Type</label>
                        <select v-if="type=='create'" v-model="editItem.reward_type" id="form-input-reward_type">
                            <option value="physical">Physical Gifts</option>
                            <option value="voucher">Digital Vouchers</option>
                            <option value="mixed">Mixed</option>
                        </select>
                        <div v-else class="form-static-field">{{ rewardTypeName(editItem.reward_type) }}</div>
                    </div>
                </div>

                <div class="form-line">
                    <div id="form-field-slug" class="form-field" style="width: 100%; text-align: left;">
                        <label for="form-input-slug">Campaign Slug</label>
                        <div style="display: flex">
                            <div style="white-space: nowrap; line-height: 37px; font-size: 14px;">{{ hubHost }}/{{ gbPageUrlBase }}/{{ team.slug }}/</div>
                            <div style="width: 100%;" ><input v-model="editItem.slug" type="text" id="form-input-slug" required="required" style="width: 100%;" /></div>
                        </div>
                    </div>
                </div>


                <div class="form-line">
                  <field-privacy :item="editItem"></field-privacy>
                </div>
            </div>

            <div class="modal-tab-content" :active="activeTab=='options'">
                <div class="form-line">
                    <div class="form-field">
                        <label for="form-input-name">Gift Options</label>
                        <textarea v-model="editItem.req_content" id="form-input-content" rows="10"></textarea>
                        <div style="text-align: left;"><br />Please provide detailed description of the content of your campaign. You can use your existing corporate product or request new ones from our corporate catalogue.<br /><br />
                            <a class="ws-button small" style="font-style: normal" href="/wp-content/plugins/worksends/files/worksends-catalogue-price-list.pdf" download>Corporate Catalogue & Price List</a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-tab-content" :active="activeTab=='page'">
                <div v-if="editItem.type=='reviews'">
                    <div class="form-line">
                        <div class="form-field" style="width: 100%">
                            <label>Review Submission URL</label>
                            <input v-model="editItem.reviews.submission_url" type="url" placeholder="https://www.example.com" pattern="https://.*" required />
                        </div>
                    </div>

                    <div class="form-line" >
                        <div class="form-field">
                            <label for="form-input-name">Review Page Title</label>
                            <input v-model="editItem.page_title" type="text" maxlength="100">
                        </div>
                    </div>

                    <div class="form-line">
                        <div class="form-field" style="width: 100%">
                            <label>Invite To Review Text</label>
                            <textarea v-model="editItem.reviews.texts.invite" type="text" rows="4" required></textarea>
                        </div>
                    </div>
                    <div class="form-line">
                        <div class="form-field" style="width: 100%">
                            <label>Rating Intro Text</label>
                            <textarea v-model="editItem.reviews.texts.rating" type="text" rows="2" required></textarea>
                        </div>
                    </div>
                    <div class="form-line">
                        <div class="form-field" style="width: 50%">
                            <label>Rating Button #1 Text</label>
                            <input v-model="editItem.reviews.buttons[0]" type="text" required />
                        </div>
                        <div class="form-field" style="width: 50%">
                            <label>Rating Button #2 Text</label>
                            <input v-model="editItem.reviews.buttons[1]" type="text" required />
                        </div>
                        <div class="form-field" style="width: 50%">
                            <label>Rating Button #3 Text</label>
                            <input v-model="editItem.reviews.buttons[2]" type="text" required />
                        </div>
                        <div class="form-field" style="width: 50%">
                            <label>Rating Button #4 Text</label>
                            <input v-model="editItem.reviews.buttons[3]" type="text" required />
                        </div>
                    </div>
                    <div class="form-line">
                        <div class="form-field">
                            <label>Fedback Form Treshold </label>
                            <select v-model="editItem.reviews.treshold" style="width: 60%; display: block;" required>
                              <option value="0">{{ editItem.reviews.buttons[0] }}</option>
                              <option value="1">{{ editItem.reviews.buttons[1] }}</option>
                              <option value="2">{{ editItem.reviews.buttons[2] }}</option>
                              <option value="3">{{ editItem.reviews.buttons[3] }}</option>
                            </select>
                            <div class="small-note" style="margin-top: 10px"><span>PRO TIP:</span> When invitee clicks this rating button or lower one, they will be taken to a feedback form instead of a review page.</div>
                        </div>
                    </div>
                    <div class="form-line">
                        <div class="form-field" style="width: 100%">
                            <label>Feedback Page Text</label>
                            <textarea v-model="editItem.reviews.texts.feedback" type="text" rows="2" required></textarea>
                        </div>
                    </div>
                    <div class="form-line">
                        <div class="form-field" style="width: 100%">
                            <label>Review Page Text (top)</label>
                            <textarea v-model="editItem.reviews.texts.review_top" type="text" rows="3" required></textarea>
                        </div>
                        <div class="form-field" style="width: 100%">
                            <label>Review Page Text (bottom)</label>
                            <textarea v-model="editItem.reviews.texts.review_bottom" type="text" rows="3" required></textarea>
                        </div>
                    </div>
                    <div class="form-line">
                        <div class="form-field" style="width: 100%">
                            <label>Gift Claim Page Text</label>
                            <textarea v-model="editItem.reviews.texts.gift_claim" type="text" rows="2" required></textarea>
                        </div>
                    </div>
                </div>

                <div v-if="editItem.type!='reviews'">
                    <div class="form-line" >
                        <div class="form-field">
                            <label for="form-input-name">Gift Claim Page Title</label>
                            <input v-model="editItem.page_title" type="text" maxlength="100">
                            <div class="small-note" style="margin-top: 10px">If you want to show your audience a page title different to the name of the campaign, you can specify it here.</div>

                        </div>
                    </div>

                    <div class="form-line">
                        <div class="form-field">
                            <label for="form-input-name">Gift Claim Page Text</label>
                            <textarea v-model="editItem.page_text" type="text" rows="8"></textarea>
                            <div class="small-note" style="margin-top: 10px"><span>TIP:</span> This text is displayed below the campaign name on your campaign gift claim page, that you can <a :href="item.registration_page" target="_blank">preview here</a>. You can find more options to customise action pages like this in the <a href="/pro/campaigns/action-pages">action pages section</a>.</div>
                        </div>
                    </div>
                </div>

                <!--
                <div class="form-line" ref="modal-tab-campaign">
                    <div class="form-line-fields">
                        <div id="form-field-base" class="form-field form-field-image-upload">
                            <label>Gift Registration Page Hero Image</label>
                            <div v-if="hero">{{ hero.name }}</div>
                            <div v-else-if="editItem.hero_url">
                                <img :src="editItem.hero_url" alt="Hero image" width="250">
                            </div>
                            <div @click="$refs.logoUploadInput.click()" class="ws-button">{{ editItem.hero_url ? 'Update' : 'Upload'}} Hero Image</div>
                            <input ref="logoUploadInput" accept="image/*" style="display: none" type="file" @change="onHeroChange">
                        </div>
                    </div>
                </div>
                -->
            </div>

            <div class="modal-tab-content" :active="activeTab=='sales'" v-if="editItem.type=='sales'">
                <div class="form-line">
                    <div class="form-field" style="width: 40%">
                        <label>Opportunity Value (£)</label>
                        <input v-model="editItem.opportunity_value" type="number" />
                    </div>
                </div>
                <div class="form-line">
                    <div class="form-field" style="width: 40%">
                        <label>Demo Value (£)</label>
                        <input v-model="editItem.demo_value" type="number"  />
                    </div>
                </div>
                <div class="form-line">
                    <div class="form-field" style="width: 40%">
                        <label>Deal Value (£)</label>
                        <input v-model="editItem.deal_value" type="number" />
                    </div>
                </div>

                <div class="form-line">
                    <div class="form-field" style="width: 80%">
                        <div class="small-note"><span>PRO TIP:</span> <b>Opportunity Value</b> value is average worth of a redeemed send. <b>Demo Value</b> is average worth of demo booked (use only if applicable). <b>Deal Value</b> is average worth of signed contract.</div>
                    </div>
                </div>
            </div>

            <div class="modal-errors">
                <p v-for="e in errors" class="form-field error-text">{{ e[0] }}</p>
            </div>
        </div>
        <div class="form-actions">
          <span class="ws-button ws-button-secondary" data-action="cancel" @click="modals.editGiftBoxCampaign = false">CANCEL</span>
          <span v-if="type=='create'" class="ws-button ws-button-main" data-action="start-campaign-confirm" @click="requestCampaign">REQUEST CAMPAIGN</span>
          <span v-if="type=='edit'" class="ws-button ws-button-main" data-action="start-campaign-confirm" @click="updateCampaign">UPDATE CAMPAIGN</span>
        </div>
    </modal>
</template>

<script>
import Modal from "@/components/modals/Modal";
import FieldPrivacy from "@/pages/gift-box-campaigns/components/FieldPrivacy";
import { hubHost } from '@/utils/hub-url';

export default {
    name: "GiftBoxCampaignsEditModal",
    components: {Modal,FieldPrivacy},
    props: {
        type: String,
        itemId: Number,
        fetchItem: {type: Boolean, default: false},
        tab: String,
        rewardType: String,
    },
    data() {
        return {
            hubHost,
            editItem: {
                name:'', slug:'', page_title: '', page_text: '', type: null, reward_type: null,
                privacy:'', disabled_domains: '', hero_url:'', auto_approve: false,
                opportunity_value: null, demo_value: null, deal_value: null, req_content: '',
                reviews: {
                    submission_url: '',
                    treshold: null,
                    buttons: [],
                    texts: {},
                },
            },
            errors: {},
            hero:null,
            activeTab: 'campaign',
        }
    },
    methods: {
        async requestCampaign() {
            if (!this.demoCheck()) return;
            
            this.errors = this.validateFields([
                { name: 'Name', value: this.editItem.name, rules: ['required', 'minLength:1'] },
                { name: 'Type', value: this.editItem.type, rules: ['required'] },
                { name: 'Reward Type', value: this.editItem.reward_type, rules: ['required'] },
                { name: 'Slug', value: this.editItem.slug, rules: ['required', 'slug'] },
                { name: 'Privacy', value: this.editItem.privacy, rules: ['required'] },
            ]);

            if (Object.keys(this.errors).length) {
                return;
            }
            if (this.item.privacy=='public') {
              this.editItem.auto_approve = false;
              this.editItem.page_restricted = false;
            }
            this.editItem.status = 'requested';
            
            try {
                let data = await this.dispatchWaitAndNotify('createGiftBoxCampaign', this.editItem);
                await this.$router.push({name: 'campaign-detail', params: {id: data.id}});
                this.modals.editGiftBoxCampaign = false;
            } catch (e) {
                console.log(e);
            }
        },
        async updateCampaign() {
            if (!this.demoCheck()) return;
            
            this.errors = this.validateFields([
                { name: 'Name', value: this.editItem.name, rules: ['required', 'minLength:1'] },
                { name: 'Type', value: this.editItem.type, rules: ['required'] },
                { name: 'Slug', value: this.editItem.slug, rules: ['required', 'slug'] },
                { name: 'Privacy', value: this.editItem.privacy, rules: ['required'] },
            ]);
            if (Object.keys(this.errors).length) return;

            if (this.editItem.privacy=='public') {
              this.editItem.auto_approve = false;
              this.editItem.page_restricted = false;
            }

            delete this.editItem.reward_type;
            delete this.editItem.req_content;
            this.editItem.reviews = JSON.stringify(this.editItem.reviews);

            const formData = new FormData();
            ['name', 'slug','page_title','page_text','type','privacy','disabled_domains','auto_approve','page_restricted','opportunity_value','demo_value','deal_value','reviews'].forEach(key => formData.append(key, this.editItem[key])); // skip hero_url
            if (this.hero) { // append hero image
                formData.append('file', this.hero)
            }
            await this.dispatchWaitAndNotify('updateGiftBoxCampaign', {campaignId: this.item.id, payload: formData});
            this.$emit('updated');
        },
        onHeroChange(event) {
            this.hero = event.target.files[0];
        },
        activateTab(tab) {
            this.activeTab = tab;
        },
        slugify() {
            if (this.type == 'create') this.editItem.slug = this.editItem.name.toLowerCase().replace(/ /g, '-').replace( /[^a-z0-9-]/g, '' );
        },
        rewardTypeName(name) {
            if (name == 'physical') return 'Physical Gifts';
            if (name == 'voucher') return 'Digital Vouchers';
            if (name == 'mixed') return 'Mixed';
            return name;
        },
        setDefaultReviewFields() {
            this.editItem.reviews = {
                submission_url: '',
                treshold: 2,
                buttons: ['Very Happy', 'Happy', 'OK', 'Unhappy'],
                texts: {
                    invite: 'We greatly appreciate feedback and reviews from of our customers. It allows us to improve our service and build our company. Please follow the steps below and we will say thanks with a voucher.',
                    rating: 'How happy are you with our service?',
                    feedback: 'Please provide us with feedback on how we can imporive our service.',
                    review_top: 'We’re very pleased to know you like our service.\nPlease click the link below to leave a review, including any constructive feedback!',
                    review_bottom: 'Once you have completed the review please click the link below to claim your thank you gift.',
                    gift_claim: 'Thank you for your valuable feedback and review. Please enjoy your vourcher.',
                },
            };
        }
    },
    async mounted() {
        if (this.tab) this.activeTab = this.tab;
        if (this.fetchItem) {
            await this.dispatchWaitAndNotify('fetchTeam', null, false, true);
            await this.dispatchWaitAndNotify('fetchGiftBoxCampaign', {campaignId: this.item.id}, false, true);
        }
        
        if (this.type=='create') {
            // Create New Gift Box Campaign
            if (this.rewardType) this.editItem.reward_type = this.rewardType;
            else this.editItem.reward_type = 'physical';
            this.editItem.type = 'year-round';
            this.editItem.privacy = 'invite';
        } else {
            // Edit Gift Box Campaign
            this.editItem.name = this.item.name;
            this.editItem.slug = this.item.slug;
            this.editItem.type = this.item.type;
            this.editItem.reward_type = this.item.reward_type;
            this.editItem.privacy = this.item.privacy;
            this.editItem.disabled_domains = this.item.disabled_domains;
            if (this.item.page_title) this.editItem.page_title = this.item.page_title;
            if (this.item.page_text) this.editItem.page_text = this.item.page_text;
            this.editItem.hero_url = this.item.hero_url;
            this.editItem.auto_approve = this.item.auto_approve;
            this.editItem.page_restricted = this.item.page_restricted;
            this.editItem.opportunity_value = this.item.opportunity_value;
            this.editItem.demo_value = this.item.demo_value;
            this.editItem.deal_value = this.item.deal_value;
            this.editItem.deal_value = this.item.deal_value;
            this.editItem.reviews = this.item.reviews;
        }
    },
    computed: {
        team() {
            return this.$store.state.team.detail;
        },
        item() {
            return this.$store.state.giftBoxCampaign.detail;
        },
        modals() {
            return this.$store.state.modals;
        },
        gbPageUrlBase() {
            return this.$store.state.gbPageUrlBase;
        }
    },
    watch: {
		'editItem.type': {
			handler (newVal, oldVal) {
				if (newVal === 'reviews' && oldVal !== newVal && this.editItem.reviews.submission_url == '') {
                    this.setDefaultReviewFields();
                }
			},
			deep: true,
		}
	}
}
</script>

<style scoped>

</style>
